import React from 'react';
import { formatTime } from 'utils/commonUtils';
import { AiOutlineInfoCircle } from 'react-icons/ai';

function TimeExceedWarning({ totalTodayTime, timeLimitPerDay }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 500 }}>
        <div style={{ fontSize: 48, marginBottom: 12, color: '#2563eb' }}>
          <AiOutlineInfoCircle />
        </div>
        <h4 style={{ fontWeight: 700, marginBottom: 16 }}>
          Đã đạt thời gian học hôm nay
        </h4>
        <p style={{ color: '#555', fontSize: 15, marginBottom: 8 }}>
          Đã học: <strong>{formatTime(totalTodayTime)}</strong> / Giới hạn: <strong>{formatTime(timeLimitPerDay)}</strong>
        </p>
        <p style={{ color: '#888', fontSize: 14 }}>
          Vui lòng quay lại vào <strong>ngày hôm sau</strong> để tiếp tục học.
        </p>
      </div>
    </div>
  );
}

export default TimeExceedWarning;
